document.addEventListener("DOMContentLoaded", function () {
  const builder = document.querySelector(".saman-addon-builder");
  if (!builder) return;

  const totalPrice = builder.querySelector(".saman-addon-total-price");
  let mainPrice = Number(builder.dataset.mainPrice || 0);

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || "Rs. {{amount}}");
    }
    return "Rs. " + (Number(cents) / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateTotal() {
    let total = mainPrice;

    builder.querySelectorAll(".saman-addon-card").forEach(function (card) {
      const btn = card.querySelector(".saman-addon-toggle");

      if (btn && btn.classList.contains("added")) {
        total += Number(card.dataset.selectedPrice || 0);
      }
    });

    if (totalPrice) {
      totalPrice.innerHTML = formatMoney(total);
    }
  }

  builder.querySelectorAll(".saman-addon-card").forEach(function (card) {
    const toggle = card.querySelector(".saman-addon-toggle");
    const variantSelect = card.querySelector(".saman-addon-variant-select");

    if (variantSelect) {
      const selected = variantSelect.options[variantSelect.selectedIndex];

      if (selected) {
        card.dataset.selectedVariantId = selected.value;
        card.dataset.selectedPrice = selected.dataset.price;
        const priceEl = card.querySelector(".saman-addon-price");
        if (priceEl) priceEl.innerHTML = formatMoney(selected.dataset.price);
      }

      variantSelect.addEventListener("change", function () {
        const selected = this.options[this.selectedIndex];

        card.dataset.selectedVariantId = selected.value;
        card.dataset.selectedPrice = selected.dataset.price;

        const priceEl = card.querySelector(".saman-addon-price");
        if (priceEl) priceEl.innerHTML = formatMoney(selected.dataset.price);

        updateTotal();
      });
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        this.classList.toggle("added");
        this.innerHTML = this.classList.contains("added") ? "✓ Added" : "+ Add";
        updateTotal();
      });
    }
  });

  document.addEventListener("submit", function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const selectedAddons = builder.querySelectorAll(".saman-addon-toggle.added");
    if (!selectedAddons.length) return;

    event.preventDefault();

    const mainVariantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');

    const items = [];

    if (mainVariantInput && !mainVariantInput.disabled) {
      items.push({
        id: Number(mainVariantInput.value),
        quantity: qtyInput ? Number(qtyInput.value || 1) : 1
      });
    }

    selectedAddons.forEach(function (btn) {
      const card = btn.closest(".saman-addon-card");
      const variantId = card.dataset.selectedVariantId;

      if (variantId) {
        items.push({
          id: Number(variantId),
          quantity: 1
        });
      }
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart add failed");
        return res.json();
      })
      .then(function () {
        window.location.href = "/cart";
      })
      .catch(function () {
        alert("Something went wrong. Please try again.");
      });
  });

  updateTotal();
});
document.addEventListener("click", function (event) {
  const addBtn = event.target.closest('[name="add"]');
  if (!addBtn) return;

  const builder = document.querySelector(".saman-addon-builder");
  if (!builder) return;

  const selectedAddons = builder.querySelectorAll(".saman-addon-toggle.added");
  if (!selectedAddons.length) return;

  event.preventDefault();
  event.stopPropagation();

  const form = addBtn.closest("form");
  if (!form) return;

  const mainVariantInput = form.querySelector('[name="id"]');
  const qtyInput = form.querySelector('[name="quantity"]');

  const items = [];

  if (mainVariantInput && !mainVariantInput.disabled) {
    items.push({
      id: Number(mainVariantInput.value),
      quantity: qtyInput ? Number(qtyInput.value || 1) : 1
    });
  }

  selectedAddons.forEach(function (btn) {
    const card = btn.closest(".saman-addon-card");
    const variantId = card.dataset.selectedVariantId;

    if (variantId) {
      items.push({
        id: Number(variantId),
        quantity: 1
      });
    }
  });

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({ items: items })
  })
  .then(function (res) {
    if (!res.ok) throw new Error("Cart add failed");
    return res.json();
  })
  .then(function () {
    window.location.href = "/cart";
  })
  .catch(function () {
    alert("Something went wrong. Please try again.");
  });
}, true);